import Utils from '@/utils/utils'
const component = () => import('../pages/my-info/my-info.vue')
const routerPath = [
  "/mynew",
  "/ddeeminelive",
  "/aamineaaliveaapgae",
  "/bbminebblivebbpgae",
  "/ccmineccliveccpgae",
  "/ddmineddliveddpgae",
  "/eemineeeliveeepgae",
  "/ffmineffliveffpgae",
  "/ggmineggliveggpgae",
  "/hhminehhlivehhpgae",
  "/iimineiiliveiipgae",
  "/jjminejjlivejjpgae",
  "/kkminekklivekkpgae",
  "/llminelllivellpgae",
  "/mmminemmlivemmpgae",
  "/nnminennlivennpgae",
  "/oomineooliveoopgae",
  "/ppminepplivepppgae",
  "/qqmineqqliveqqpgae",
  "/rrminerrliverrpgae",
  "/xxminexxlivexxpgae",
  "/zsminezslivezspgae",
  "/sdminesdlivesdpgae",
  "/weminewelivewepgae",
  "/fdsminefdlivefdpgae",
  "/xcvminexclivexcpgae",
]

const routerList = routerPath.map((path) => {
  return Utils.createRouterItem({
    path,
    meta: {
      title: '我的',
      showBottom: true
    },
    component,
  })
})
export default routerList